import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export const accountRemoval = () => {
  return axios.post(`${API_URL}/account-removal`);
};
